<template>
  <div class="counter">
    <!-- Quantity controls -->
    <button class="counter__btn minus" type="button" @click="decrementQuantity()">
      - <!-- Decrement button -->
    </button>
    <input
        v-model="quantity"
        class="counter__input"
        type="text"
        @blur="validateQuantity()"
        @input="updateQuantity()"
    >
    <button class="counter__btn plus" type="button" @click="incrementQuantity()">
      + <!-- Increment button -->
    </button>
  </div>
</template>

<script>

export default {
  name:     "AddToCartCounter",
  emits:    [
    'update-select-quantity'
  ],
  computed: {
    quantity: {
      get() {
        return this.$store.getters.quantity
      },
      set(value) {
        this.$emit('update-select-quantity', value)
        this.$store.commit('SET_QUANTITY', value)
      },
    },
  },
  data() {
    return {
      productQuantity: 100
    }
  },
  methods:  {
    // Handle the quantity update when the input field changes
    // You may want to add validation here as well
    updateQuantity() {
      if (this.quantity < 1) {
        this.quantity = 1; // Ensure a minimum quantity of 1
      }
      if (this.quantity > this.productQuantity) {
        this.quantity = this.productQuantity;
      }
    },

    // Decrement the quantity by 1
    decrementQuantity() {
      if (this.quantity > 1) {
        this.quantity--;
      }
    },

    // Increment the quantity by 1
    incrementQuantity() {
      if (this.quantity < this.productQuantity) {
        this.quantity++;
      }
    },

    // Perform any additional validation if needed when the input loses focus
    validateQuantity() {
      if (this.quantity < 1) {
        this.quantity = 1; // Ensure a minimum quantity of 1
      }
    },
  }
}
</script>